import React, { FC } from 'react';

import { PROGRESS_BAR_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { ColorPicker } from 'components/ui/ColorPicker/color-picker';

import {
  FormFieldsGradientRow,
  FormFieldsIdentitySection,
  FormFieldsNumberRow,
  FormFieldsSection,
  FormFieldsUploadSection
} from '../components';

import { useFormFieldsContext } from '../../../context';

import {
  BAR_FILL_COLOR_FIELD,
  BAR_NUMBER_FIELDS,
  BORDER_GRADIENT_FIELDS,
  FRAME_NUMBER_FIELDS,
  UPLOAD_FIELDS
} from './ProgressBarFormFields.consts';

export const ProgressBarFormFields: FC = (): React.ReactElement => {
  const { values, setFieldValue } = useFormFieldsContext();

  return (
    <React.Fragment>
      <FormFieldsSection
        heading="Progress Bar"
        description="Customize the progress bar to fit your store theme."
      >
        <FormFieldsIdentitySection spacing="none" />
      </FormFieldsSection>

      <FormFieldsSection
        heading="Progress Bar Frame"
        description="Set your frame settings."
        showSeparator
      >
        <FormFieldsNumberRow fields={FRAME_NUMBER_FIELDS} />
      </FormFieldsSection>

      <FormFieldsSection
        heading="Progress Bar Design"
        description="Set colors and upload assets for your bar."
        showSeparator
      >
        <div className="flex gap-5">
          <div className="flex-1">
            <ColorPicker
              label="Font Color"
              data-testid="offer-design-progress-bar-font-color-input"
              defaultValue={values.textColor || PROGRESS_BAR_DEFAULTS.textColor}
              onChange={(color) => setFieldValue('textColor', color)}
            />
          </div>
          {/* TODO: Aligned with Jonathan — replace AcGradientInput (MUI) with new component when available */}
          <FormFieldsGradientRow
            fields={[BAR_FILL_COLOR_FIELD]}
            layout="flex"
          />
        </div>

        {/* TODO: Aligned with Jonathan — replace AcGradientInput (MUI) with new component when available */}
        <FormFieldsGradientRow fields={BORDER_GRADIENT_FIELDS} spacing="sm" />

        <FormFieldsNumberRow fields={BAR_NUMBER_FIELDS} spacing="sm" />

        <FormFieldsUploadSection fields={UPLOAD_FIELDS} spacing="lg" />
      </FormFieldsSection>
    </React.Fragment>
  );
};
